import React from "react";
import BankAccountDisplay from "@components/BankAccountDisplay";
import {
  SET_BANK_ACCOUNT_TO_REMOVE,
  SET_OPEN_REMOVE_BANK_ACCT_MODAL,
  SET_OPEN_ADD_BANK_ACCT_MODAL
} from "@constants/achActionTypes";
import { defaultAction } from "@actions/defaultAction";
import { getBuyAndSellBankAccounts } from "@modules/Cart/selector";
import styled from "@emotion/styled";
import { FaTrashAlt } from "react-icons/fa";
import DefaultCustomButton from "@modules/Components/DefaultCustomButton";
import { useDispatch, useSelector } from "react-redux";

const MainBankAccountDisplay = styled.div`
  margin-bottom: 20px;

  @media (max-width: 924px) {
    width: 85%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  @media (max-width: 728px) {
    width: 90%;
  }
`;

const DisplayCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  border-bottom: 1px solid rgba(119, 121, 132, 0.15);
  padding-bottom: 20px;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 22px;

  @media (max-width: 975px) {
    padding-left: 0px;
    padding-right: 0px;
  }
  @media (max-width: 400px) {
    grid-template-columns: 1.5fr 1fr;
  }
`;

const TrashContainer = styled.div`
  justify-self: flex-end;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: center;
  align-items: center;
  grid-gap: 35px;
`;

const DefaultContainer = styled.div`
  border-radius: 5px;
  background-color: rgba(119, 121, 132, 0.1);
  font-size: 14px;
  font-weight: bold;
  color: #777984;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  @media (max-width: 400px) {
    font-size: 13px;
    width: auto;
    padding-right: 9px;
    padding-left: 9px;
    height: 33px;
  }
  @media (max-width: 340px) {
    font-size: 12px;
    padding-right: 8px;
    padding-left: 8px;
    height: 30px;
  }
  @media (max-width: 320px) {
    font-size: 10px;
    padding-right: 7px;
    padding-left: 7px;
    height: 26px;
  }
  @media (max-width: 305px) {
    font-size: 9px;
  }
`;

const IconContainer = styled.div`
  grid-column: 2/3;
`;

const AddCard = styled.div`
  cursor: pointer;
  width: fit-content;
  margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.71;
  color: #12b2ea;
`;

const AddCardSpan = styled.span`
  color: rgba(18, 178, 234, 0.4);
`;

const NoCardsMain = styled.div`
  @media (max-width: 975px) {
    padding-top: 43px;
  }
`;

const ImageContainer = styled.div`
  height: auto;
  width: 341px;
  margin: 0 auto;
  min-height: 341px;
  margin-top: -65px;

  @media (max-width: 360px) {
    width: 100%;
  }
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  margin-top: -54px;
  margin-bottom: 25px;

  @media (max-width: 450px) {
    font-size: 27px;
  }
  @media (max-width: 360px) {
    font-size: 25px;
  }
  @media (max-width: 350px) {
    margin-top: -88px;
  }
  @media (max-width: 305px) {
    margin-top: -105px;
  }
`;

const CreditP = styled.div`
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  color: #777984;
  margin-bottom: 40px;

  @media (max-width: 450px) {
    font-size: 15px;
  }
  @media (max-width: 315px) {
    font-size: 14px;
  }
  @media (max-width: 290px) {
    font-size: 13px;
  }
`;

const BankAccounts = () => {
  const dispatch = useDispatch();
  const bankAccounts = useSelector(state =>
    getBuyAndSellBankAccounts({
      paymentMethods: state.paymentMethods.buyAndSellPaymentMethods
    })
  );

  const openModal = () => {
    dispatch(defaultAction(SET_OPEN_ADD_BANK_ACCT_MODAL, true));
  };

  return (
    <MainBankAccountDisplay>
      {bankAccounts && bankAccounts.length ? (
        <div>
          {bankAccounts.map((bankAccount, index) => (
            <DisplayCards key={index}>
              <BankAccountDisplay
                account_type={bankAccount.account_type}
                account={bankAccount.account}
                routing={bankAccount.routing}
              />
              <TrashContainer>
                {bankAccount.default && (
                  <DefaultContainer>Default</DefaultContainer>
                )}
                <IconContainer>
                  <FaTrashAlt
                    style={{ opacity: 0.3, cursor: "pointer" }}
                    size={15}
                    onClick={() => {
                      dispatch(
                        defaultAction(SET_BANK_ACCOUNT_TO_REMOVE, bankAccount)
                      );
                      dispatch(
                        defaultAction(SET_OPEN_REMOVE_BANK_ACCT_MODAL, true)
                      );
                    }}
                  />
                </IconContainer>
              </TrashContainer>
            </DisplayCards>
          ))}
          <AddCard onClick={openModal}>
            <AddCardSpan>+</AddCardSpan> Add a bank account
          </AddCard>
        </div>
      ) : (
        <NoCardsMain className="no-cc-cards">
          <ImageContainer>
            <img
              src={
                "https://cdn.cardcash.com/website/ui/elements/no-cards-bird.svg"
              }
              alt="no bank accounts"
            />
          </ImageContainer>
          <Header>No Bank Account Found</Header>
          <CreditP>Add a bank account to get paid.</CreditP>
          <DefaultCustomButton
            handleClick={openModal}
            classes={"main-default-orange-button"}
            type="button"
            disabled={false}
            buttonType={"ORANGE_BUTTON"}
            name="submit"
          >
            <span>Add a bank account</span>
          </DefaultCustomButton>
        </NoCardsMain>
      )}
    </MainBankAccountDisplay>
  );
};

export default BankAccounts;
